<template>
  <div class="play-unsolicited-effect">
    <unsolicited-items
      :emitter="emitter"
      :items="emitter.caseConf.dialogue.unsolicited"
      :selected="state.effect.id"
      :control="control"
      :readonly="readonly"
      @update="selectUnsolicited"
    />
    <div class="el-input-group el-input-group--append el-input-group--prepend">
      <div class="el-input-group__prepend">To</div>
      <character-select
        :selected="state.effect.targetCharacterKey"
        :characters="getTargetCharacters(emitter.caseConf)"
        :disabled="readonly"
        :errors="missingTargetCharacterErrors"
        placeholder="Select Target Character"
        @input="selectTargetCharacter"
      />
    </div>
  </div>
</template>

<script>
import { getTargetCharacters } from '~lib/common/utils/characters';
import nodeMixins from './mixins/NodeMixins';

import CharacterSelect from './CharacterSelect.vue';
import UnsolicitedItems from './UnsolicitedItems.vue';

export default {
  name: 'play-unsolicited-effect',
  components: {
    CharacterSelect,
    UnsolicitedItems,
  },
  mixins: [ nodeMixins ],
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
        effect: {},
      },
    };
  },
  computed: {
    missingTargetCharacterErrors() {
      return this.getErrorsById('missingTargetCharacter');
    },
  },
  mounted() {
    this.syncState();
    this.emitter.on('process', (nodeOrControl) => {
      // Update internal state when the node data changes
      // outside (e.g. from a CallAction)
      if (nodeOrControl === this.control) {
        this.syncState();
      }
    });
    this.emitter.trigger('process', this.control);
  },
  methods: {
    syncState() {
      this.state.effect = this.getData(this.ikey) || {};
    },
    selectUnsolicited(unsolicitedId) {
      this.state.effect.id = unsolicitedId;
      this.update();
    },
    selectTargetCharacter(key) {
      this.state.effect.targetCharacterKey = key;
      this.update();
    },
    update() {
      this.putData(this.ikey, { type: 'UNSOLICITED_DIALOGUE', ...this.state.effect });
      this.emitter.trigger('process', this.control);
      this.$forceUpdate();
    },
    getTargetCharacters,
  },
};
</script>

<style scoped>
</style>
